import React from 'react';
import {ImageBackground, Text, TouchableOpacity, useWindowDimensions, View} from 'react-native';
import {connect} from 'react-redux';
import {useNavigation} from '@react-navigation/native';

import {LastUpdateDate} from '@components/atoms';
import imageProfile from '@images/profile-header2.png';
import Menu from '@images/icons/menu.svg';
import {styles} from './styles';
import WalletIcon from "@images/icons/wallet.svg";

const Header = ({
                    displayName,
                    subtitle,
                    detail,
                    welcome,
                    lastUpdateDate,
                    style,
                    icon,
                }) => {
    const navigation = useNavigation();

    const {width} = useWindowDimensions();

    return (
        <ImageBackground
            source={imageProfile}
            style={[
                styles.image,
                style,
                {flexDirection: 'row', justifyContent: 'space-between'},
            ]}
        >
            <View>
                {width < 1070 && (
                    <TouchableOpacity onPress={() => navigation.openDrawer()}>
                        <Menu/>
                    </TouchableOpacity>
                )}
                {!!displayName && <Text style={styles.text}>{displayName}</Text>}
                {!!icon && (
                    <View style={{paddingRight: 15, alignItems: 'center', justifyContent: 'center'}}>
                        <WalletIcon/>
                    </View>
                )}
                {welcome && (
                    <Text style={styles.title}>Добро пожаловать в приложение</Text>
                )}
            </View>
            {!(width < 1070) &&  (
                <LastUpdateDate style={[styles.title, styles.details]}/>
            )}
        </ImageBackground>
    );
};

const mapStateToProps = ({user}) => ({
    user,
    isLogin: !!user.id,
    displayName: user.displayName,
});

export const HeaderProfile = connect(mapStateToProps)(Header);
